export default __webpack_public_path__ + "static/media/Ll.2233f07c.wav";